// extracted by mini-css-extract-plugin
export default {"manageButton":"CookieConsentManager_manageButton__sUBPl","icon":"CookieConsentManager_icon__RwrWI"};